/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Content_LabelInputs */



/**
* | output |
* | --- |
* | "Content" |
*
* @param {Error_Nav_Content_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_content_label = /** @type {((inputs?: Error_Nav_Content_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Content_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contenu")
	if (locale === "de") return /** @type {LocalizedString} */ ("Inhalt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contenuto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Содержание")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contenido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("内容")
	if (locale === "ja") return /** @type {LocalizedString} */ ("コンテンツ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सामग्री")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Contente")
	return /** @type {LocalizedString} */ ("Content")
});